module.exports = __webpack_public_path__ + "media/images/euro-a54954fc45bdd82bb02c5044d09128ec.png";